import {PaginationModel} from '../screens/models/Onlinekeys-search.model';

export class LazyLoadingData {
  arrangementNumber: string;
  administrationCode: string;
  lazyLoadingUrl: string;
  paginationObj: PaginationModel;
  data;

  constructor(arrangementNumber: string, administrationCode: string, lazyLoadingUrl: string, paginationObj?: PaginationModel) {
    this.arrangementNumber = arrangementNumber;
    this.administrationCode = administrationCode;
    this.lazyLoadingUrl = lazyLoadingUrl;
    this.paginationObj = paginationObj;
  }
}
